<template lang="html">
    <div>
        <h3 v-if="showHeadline" class="text-xl leading-6 font-medium">{{ headline }}</h3>
        <dl class="mt-5 tile stats"
            :class="{
            'flex flex-row justify-start lg:justify-between bg-white overflow-hidden divide-gray-200 md:divide-y-0 md:divide-x': !showGrid,
            'gap-0 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5': showGrid && gridCols === 5,
            'gap-0 grid grid-cols-1 xs:grid-cols-2 xl:grid-cols-4': showGrid && gridCols === 4}">
            <slot/>
        </dl>
    </div>
</template>

<script>
import Stat from '@/Shared/Stat';

export default {
    components: {
        Stat
    },
    props: {
        headline: {
            type: String,
            default: 'Headline'
        },
        showHeadline: {
            type: Boolean,
            default: true
        },
        showGrid: {
            type: Boolean,
            default: false
        },
        gridCols: {
            type: Number,
            default: 2
        },
        gridColsSm: Number,
        gridColsMd: Number,
        gridColsLg: Number,
        gridColsXl: Number,
        gridCols2Xl: Number,
    },
    methods: {
    }
}
</script>
